<section id="extended">
    <div class="form-row">
        <div class="col-12">
            <div class="rcx-table">
                <div class="card btr">
                    <div class="card-content">
                        <ul class="nav nav-tabs pt-3 ps-3" role="tablist">
                            <li class="nav-item" (click)="setActiveTabParam('LEAVES')"
                                [class.active]="currentTab === 'LEAVES'">
                                <a class="nav-link " [class.active]="currentTab === 'LEAVES'" id="table1-tab"
                                    data-bs-toggle="tab" href="#LEAVES" role="tab" aria-controls="table1"
                                    aria-selected="true"><i class="bx bx-notepad align-middle pe-1"></i>Leaves</a>
                            </li>
                            <li class="nav-item" (click)="setActiveTabParam('APPROVAL')"
                                [class.active]="currentTab === 'APPROVAL'">
                                <a class="nav-link" [class.active]="currentTab === 'APPROVAL'" id="table2-tab"
                                    data-bs-toggle="tab" href="#APPROVAL" role="tab" aria-controls="table2"
                                    aria-selected="false"><i class="bx bx-check align-middle pe-1"></i>Approval</a>
                            </li>
                        </ul>
                        <app-leaves *ngIf="currentTab==='LEAVES'"></app-leaves>
                        <app-leave-approval *ngIf="currentTab==='APPROVAL'"></app-leave-approval>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>
